import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnInit,
  Signal,
  WritableSignal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { DynamicMaskFormComponent } from './dynamic-mask-form/dynamic-mask-form.component';
import { SubscriptionConfigStore } from '../../../../../services/api/subscription/subscription-config-store.service';
import { IMask } from '@web/dtos';
import { ProgressTrackerSupportService } from '../../../../../services/support/progress-tracker-support/progress-tracker-support.service';

@Component({
  selector: 'aw-subscription-mask-step',
  imports: [CommonModule, DynamicMaskFormComponent],
  templateUrl: './subscription-mask-step.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionMaskStepComponent implements OnInit {
  private readonly route: ActivatedRoute = inject(ActivatedRoute);
  private readonly store: SubscriptionConfigStore = inject(
    SubscriptionConfigStore
  );
  protected readonly progressTracker: ProgressTrackerSupportService = inject(
    ProgressTrackerSupportService
  );

  protected currentStep: WritableSignal<number> =
    this.progressTracker.currentStep;

  ngOnInit() {
    this.route.params.subscribe(params => {
      const currentStep: number = +params['step'];
      if (currentStep) {
        this.currentStep.set(currentStep);
      } else {
        this.currentStep.set(0);
      }
    });
  }

  readonly mask: Signal<IMask | undefined> = computed(() => {
    const mask: IMask[] | undefined = this.store.baseMasks();
    return mask?.[this.currentStep()];
  });
}
